import router from '@/router'
import { authDB, setToken, removeToken } from '@/utils/auth'
import { login, getUserInfo } from '@/utils/api'

const state = {
  token: '',
  roles: [],
  userInfo: {}
}
/*
const getters = {
  userInfo: state.userInfo,
  token: state.token,
  roles: state.roles,
}
*/
const mutations = {
  SET_INFO: (state, info) => {
    const { uid } = info
    authDB.set('uid', uid)
    state.userInfo = info
  },
  SET_TOKEN: (state, token) => {
    setToken(token)
    state.token = token
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  }
}

const actions = {
  // user login
  login({ commit, dispatch }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ email: username.trim(), password: password }).then(response => {
        const { token, roles, ...userInfo } = response;
        commit('SET_TOKEN', token)
        commit('SET_ROLES', roles)
        commit('SET_INFO', userInfo)
        
        // 登录后立即生成路由
        dispatch('permission/generateRoutes', roles, { root: true }).then(accessRoutes => {
          // 动态添加路由
          router.addRoutes(accessRoutes)
          resolve()
        })
      }).catch(error => {
        reject(error)
      })
    })
  }, 

  // user logout
  logout({ commit, state, dispatch }) {
    commit('SET_TOKEN', '')
    commit('SET_ROLES', [])
    removeToken()

    // 重置路由
    router.resetRouter()
    
    // 跳转到登录页
    router.push('/login')
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getUserInfo().then(response => {
        if (!response) {
          reject('Verification failed, please Login again.')
        }

        const { token, roles, ...userInfo } = response;
        
        // 确保 roles 是数组格式
        const userRoles = Array.isArray(roles) ? roles : [roles]
        
        commit('SET_INFO', userInfo)
        commit('SET_TOKEN', token)
        commit('SET_ROLES', userRoles)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token'
    commit('SET_TOKEN', token)
    setToken(token)

    const { roles } = await dispatch('getInfo')

    // 重置路由
    router.resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })

    // dynamically add accessible routes
    router.addRoute(accessRoutes)

    // reset visited views and cached views
    // dispatch('tagsView/delAllViews', null, { root: true })
  }
}

export default {
  namespaced: true,
  state,
  // getters,
  mutations,
  actions
}
